export interface SurveyAddonButtons {
    replyButtonLabel: string;
    sendButtonLabel: string;
    backButtonLabel: string;
    nextButtonLabel: string;
}

export const initialSurveyAddonButtons: SurveyAddonButtons = {
    replyButtonLabel: 'Ответить',
    sendButtonLabel: 'Отправить',
    backButtonLabel: '❮',
    nextButtonLabel: 'Далее 👉',
};
